import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 04EE87F5-A61D-4CD0-89E5-BE7032F07A00
 * name pine-tree-variant
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pine-tree-variant.svg
 * tags
 * - Nature 
 * - Places 
 * - Agriculture 
 */
export const PineTreeVariantIcon = createSvgIcon(<><path d="M19 12L12 2L5 12H6.86L3 18H10V22H14V18H21L17.14 12H19Z" /></>, 'PineTreeVariantIcon');
export default PineTreeVariantIcon